import { render, staticRenderFns } from "./DictionaryModalTable.vue?vue&type=template&id=01db94ea&"
import script from "./DictionaryModalTable.vue?vue&type=script&lang=js&"
export * from "./DictionaryModalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports